const STORE_IMAGE_TO_TEMP_BUCKET = 'webservice/store-image-to-temp-bucket';

function uploadSignature({image, customer_id, attribute_id}) {
    let image_type = 'signature';
    const formData = new FormData();
    formData.append('image', image);
    formData.append('customer_id', customer_id);
    formData.append('attribute_id', attribute_id);
    formData.append('image_type', image_type);
    formData.append('for_ajax', true);
    return window.axios.post(STORE_IMAGE_TO_TEMP_BUCKET, formData);
}

module.exports = {
    uploadSignature: uploadSignature
};  
